// Import React and Hooks
import React, { useEffect, useState } from 'react'
// Import Redux and Hooks
import { Dispatch } from "redux"
import { useAppSelector, useAppDispatch } from '../hooks/useRedux'
// Import Actions
import { downloadTermsDataAction } from '../actions/termsAction'
// Import Components
//import Background from './../components/layout/Background'
import AccordionItem from '../components/ui/AccordionItem'



const Terms = () => {



  // Use dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use Selector
  const termsData = useAppSelector( state => state.terms.termsData )



  // Use state
  const [ currentTab, setCurrentTab ] = useState('')



  // Use effect
  useEffect( () => {
    dispatch( downloadTermsDataAction() )
  }, [] )

  useEffect( () => {
    let counter = 0
    if( termsData.length > 0 && counter === 0 ) {
      setCurrentTab( `${termsData[0].type}0` )
      counter++
    }
  }, [termsData])




  // Functions
  function handleChangeTab( idTerm:string ) {
    setCurrentTab( idTerm )
  }




  return (
    <div className="container container--terms">

      <h2 className="container__title">
        Términos y condiciones
      </h2>

      <section className="tabSide">
        <nav className="tabSide__nav">
          { termsData.length > 0 && (
            termsData.map( (termItem:any, index:number) => {
              const idTerm = `${termItem.type}${index}`
              return <span
                data-tabside={idTerm}
                className={`tabSide__nav__link ${ idTerm === currentTab ? 'active' : '' }`}
                onClick={ () => handleChangeTab( idTerm ) }
                key={idTerm} >
                { termItem.title }
              </span>
             } )
          )  }
        </nav>
        <div className="tabSide__wrapper">
          { termsData.length > 0 && (
            termsData.map( (termItem:any, index:number) => {
              const idTerm = `${termItem.type}${index}`
              return <article
                className={`tabSide__container ${ idTerm === currentTab ? 'active' : '' }`}
                data-tabside={ idTerm }
                key={ idTerm } >
                <section className="accordion">
                  { termItem.items.map( (termSingle:any, index:number) => {
                    return <AccordionItem
                      accordionItem={{ title: termSingle.title, content: termSingle.text }}
                      key={`${termSingle}${index}`} />
                  } ) }
                </section>
              </article>
             } )
          )  }
        </div>
      </section>

    </div>
    )
}



export default Terms
